const application = {
  // Page Title
  pageTitle: '入学申请表',
  pageSubtitle: '加入赛义学院学习中文',
  
  // Progress Steps
  steps: {
    personal: '个人信息',
    contact: '联系方式',
    academic: '学术信息',
    documents: '所需文件',
    motivation: '动机与目标',
    review: '审核提交'
  },
  
  // Personal Information
  personal: {
    title: '个人信息',
    subtitle: '请准确填写您的个人信息',
    fullName: '全名（阿拉伯语）',
    fullNamePlaceholder: '请输入您的阿拉伯语全名',
    fullNameEn: '全名（英语）',
    fullNameEnPlaceholder: '请输入您的英语全名',
    dateOfBirth: '出生日期',
    gender: '性别',
    male: '男',
    female: '女',
    nationality: '国籍',
    nationalityPlaceholder: '选择您的国籍',
    idNumber: '身份证/护照号码',
    idNumberPlaceholder: '请输入您的身份证或护照号码',
    placeOfBirth: '出生地',
    placeOfBirthPlaceholder: '请输入您的出生地'
  },
  
  // Contact Information
  contact: {
    title: '联系方式',
    subtitle: '我们如何联系您？',
    phone: '电话号码',
    phonePlaceholder: '请输入您的电话号码',
    whatsapp: 'WhatsApp号码',
    whatsappPlaceholder: '请输入您的WhatsApp号码',
    email: '电子邮箱',
    emailPlaceholder: '请输入您的电子邮箱',
    address: '地址',
    addressPlaceholder: '请输入您的完整地址',
    city: '城市',
    cityPlaceholder: '请输入您的城市',
    emergencyContact: '紧急联系人',
    emergencyContactPlaceholder: '姓名和电话号码',
    emergencyRelation: '关系',
    emergencyRelationPlaceholder: '例如：父亲、兄弟、朋友'
  },
  
  // Academic Information
  academic: {
    title: '学术信息',
    subtitle: '告诉我们您的教育背景',
    program: '申请课程',
    programPlaceholder: '选择课程',
    hsk1: 'HSK 一级',
    hsk2: 'HSK 二级',
    hsk3: 'HSK 三级',
    hsk4: 'HSK 四级',
    hsk5: 'HSK 五级',
    hsk6: 'HSK 六级',
    yct: 'YCT - 青少年汉语考试',
    businessChinese: '商务汉语',
    educationLevel: '教育程度',
    educationLevelPlaceholder: '选择您的教育程度',
    highSchool: '高中',
    diploma: '大专',
    bachelor: '本科',
    master: '硕士',
    doctorate: '博士',
    previousSchool: '之前的学校/大学',
    previousSchoolPlaceholder: '教育机构名称',
    gpa: '平均成绩',
    gpaPlaceholder: '请输入您的平均成绩',
    chineseLevel: '当前中文水平',
    chineseLevelPlaceholder: '选择您的水平',
    beginner: '初学者',
    elementary: '初级',
    intermediate: '中级',
    advanced: '高级',
    previousChinese: '您之前学过中文吗？',
    yes: '是',
    no: '否',
    previousDetails: '之前学习详情',
    previousDetailsPlaceholder: '您在哪里、什么时候学过中文？'
  },
  
  // Documents
  documents: {
    title: '所需文件',
    subtitle: '请上传以下文件（PDF或图片）',
    photo: '个人照片',
    photoDesc: '白色背景的近期照片',
    idCopy: '身份证/护照复印件',
    idCopyDesc: '清晰的身份证件复印件',
    certificates: '学历证书',
    certificatesDesc: '最新获得的学历证书',
    transcript: '成绩单',
    transcriptDesc: '最近学习阶段的成绩单',
    uploadButton: '选择文件',
    changeButton: '更换文件',
    uploaded: '已上传',
    notUploaded: '未上传',
    maxSize: '最大：5 MB',
    supportedFormats: '支持格式：JPG、PNG、PDF'
  },
  
  // Motivation
  motivation: {
    title: '动机与目标',
    subtitle: '告诉我们您的动机和目标',
    whyStudy: '您为什么想学习中文？',
    whyStudyPlaceholder: '解释您学习中文的动机（150-500字）',
    goals: '您的未来目标是什么？',
    goalsPlaceholder: '掌握中文后您希望实现什么？（150-500字）',
    interests: '您对中国文化的兴趣',
    interestsPlaceholder: '中国文化的哪些方面吸引您？',
    careerPlans: '职业规划',
    careerPlansPlaceholder: '中文将如何帮助您的职业发展？',
    charCount: '字数'
  },
  
  // Review
  review: {
    title: '审核申请',
    subtitle: '提交前请审核所有信息',
    personalInfo: '个人信息',
    contactInfo: '联系方式',
    academicInfo: '学术信息',
    documentsInfo: '文件',
    motivationInfo: '动机与目标',
    edit: '编辑',
    declaration: '我声明所提供的所有信息真实准确',
    terms: '我同意条款和条件',
    viewTerms: '查看条款和条件'
  },
  
  // Success
  success: {
    title: '申请提交成功！',
    subtitle: '感谢您申请赛义学院',
    applicationNumber: '申请编号',
    nextSteps: '后续步骤',
    step1: '您的申请将在3-5个工作日内审核',
    step2: '我们将通过电子邮件或电话联系您',
    step3: '您可能需要参加面试或水平测试',
    step4: '录取后，您将收到录取通知书和注册说明',
    backHome: '返回首页',
    viewCourses: '浏览课程',
    contactUs: '联系我们'
  },
  
  // Buttons
  buttons: {
    next: '下一步',
    previous: '上一步',
    submit: '提交申请',
    save: '保存',
    cancel: '取消'
  },
  
  // Validation
  validation: {
    required: '此字段为必填项',
    invalidEmail: '电子邮箱格式不正确',
    invalidPhone: '电话号码格式不正确',
    minLength: '至少需要{min}个字符',
    maxLength: '不得超过{max}个字符',
    fileSize: '文件大小不得超过5 MB',
    fileType: '不支持的文件类型'
  }
};

export default application;